import React, { useState, useRef, useEffect } from "react";
import logo from "../Assets/logo.svg";
import { Check, Circle, SignOut } from "@phosphor-icons/react";
import "../Styles/onboard.css";
import AboutHotel from "./Onboard sections/AboutHotel/AboutHotel";
import MediaGallery from "./Onboard sections/Media Gallery/MediaGallery";
import { logout } from "../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AddRoom from "./Onboard sections/3. Upload room/AddRoom";
import Service from "./Onboard sections/Services/Service";
import Menu from "./Onboard sections/Menu/Menu";
import AddStaff from "./Onboard sections/Staff-Info/AddStaff";

const steps = [
    {
        title: "ABOUT HOTEL",
        component: <AboutHotel isCompleted={(status) => console.log(status)} />,
        description: "Enter your hotel's name, location, contact details,",
    },
    {
        title: "MEDIA GALLERY",
        component: (
            <MediaGallery isCompleted={(status) => console.log(status)} />
        ),
        description: "Upload high-quality images and videos of your hotel ",
    },
    {
        title: "UPLOAD ROOM INVENTORY",
        component: <AddRoom isCompleted={(status) => console.log(status)} />,
        description:
            "Add details of each room type, features, pricing, and availability.",
    },
    {
        title: "SETUP SERVICES",
        component: <Service isCompleted={(status) => console.log(status)} />,
        description: "List all available services, (e.g., room service, spa).",
    },
    {
        title: "ADD AMENITIES",
        component: <Menu isCompleted={(status) => console.log(status)} />,
        description: "Upload restaurant and room service menus.",
    },
    {
        title: "ADD STAFF INFO",
        component: <AddStaff isCompleted={(status) => console.log(status)} />,
        description:
            "Provide key staff members' roles and contact information.",
    },
];

const Onboarding = () => {
    const location = useLocation();
    const  title = location?.state?.title || ""; 
    const [currentStep, setCurrentStep] = useState(0);
    const [stepStatus, setStepStatus] = useState(
        steps.map(() => ({ isCompleted: false })),
    );
    const contentRefs = useRef(steps.map(() => React.createRef()));
    const [lineHeights, setLineHeights] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const newLineHeights = contentRefs.current.map((ref, index) => {
            if (index < steps.length - 1) {
                const currentHeight = ref.current?.offsetHeight || 0;
                return currentHeight > 40 ? currentHeight - 8 : currentHeight;
            }
            return 0;
        });
        setLineHeights(newLineHeights);
    }, []);

    const handleComplete = (stepIndex) => {
        setStepStatus((prevStatus) =>
            prevStatus.map((status, index) =>
                index === stepIndex ? { isCompleted: true } : status,
            ),
        );
    };

    const isNextButtonEnabled = () => {
        return true;
    };

    const handleNext = () => {
        if (isNextButtonEnabled() && currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleLogout = () => {

        dispatch(logout());
        navigate("/");
    };

    const handleStepClick = (index) => {
        if(title){
            setCurrentStep(index);
        }
        else{
            if (index <= currentStep) {
                setCurrentStep(index);
            }
        }
    };

    const handleHome = ()=>{
        try{

            navigate("/dashboard/request")
        }catch(error){
            console.log(error)
        }
    }

    return (
        <div className="flex flex-col h-screen">
            
            {/* Header */}
            <header className="fixed w-full flex justify-between h-[80px] items-center px-14 py-6 bg-white z-50">
                <div
                    className="flex items-center cursor-pointer"
                    // onClick={() => navigate("/")}
                >
                    <img src={logo} alt="logo" />
                    <h1 className="text-2xl text-[#050F4E]">Alfred</h1>
                </div>
                <div
                    className="flex gap-4 items-center"
                   
                >
                    <div className="flex items-center border-[1.5px] border-[#FF7378] px-4 py-2 rounded-lg font-semibold cursor-pointer gap-2 text-[#050f4e]"
                        onClick={handleLogout}
                    >
                        Logout
                        <SignOut weight="fill" />
                    </div>
                    {
                        title && 
                        <div
                            className="flex items-center border-[1.5px] border-[#FF7378] px-4 py-2 rounded-lg font-semibold cursor-pointer gap-2 text-[#050f4e]"
                            onClick={()=>handleHome()}
                        >
                            Back
                            <SignOut weight="fill" />
                        </div>
                    }
                </div>

            </header>


            <div className="flex flex-1 mt-[80px] text-sm">
                <div
                    className="w-1/4 p-6 h-[calc(100vh-80px)] overflow-scroll border-r-[1.5px]  "
                    style={{ scrollbarWidth: "none" }}
                >
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="mb-6 relative"
                            onClick={() => handleStepClick(index)}
                        >
                            <div className="flex items-start">
                                <div className="relative">
                                    <div
                                        className={`w-8 h-8 rounded-full flex items-center justify-center z-10 
                                        ${
                                            currentStep > index
                                                ? "bg-red-500"
                                                : currentStep === index
                                                ? "border-2 border-red-500"
                                                : "border-2 border-gray-300"
                                        }`}
                                    >
                                        {currentStep > index ? (
                                            <Check
                                                weight="bold"
                                                className="text-white w-5 h-5"
                                            />
                                        ) : currentStep === index ? (
                                            <Circle
                                                weight="fill"
                                                className="text-red-500 w-3 h-3"
                                            />
                                        ) : null}
                                    </div>
                                    {index < steps.length - 1 && (
                                        <div
                                            className={`absolute left-1/2 top-8 w-0.5 -translate-x-1/2 ${
                                                currentStep > index
                                                    ? "bg-red-500"
                                                    : "bg-gray-300"
                                            }`}
                                            style={{
                                                height: `${lineHeights[index]}px`,
                                            }}
                                        ></div>
                                    )}
                                </div>
                                <div
                                    className="ml-4"
                                    ref={contentRefs.current[index]}
                                >
                                    <h3
                                        className={`${
                                            currentStep >= index
                                                ? "text-black"
                                                : "text-gray-500 hover:text-black"
                                        } font-semibold cursor-pointer`}
                                    >
                                        {step.title}
                                    </h3>
                                    <p className="text-gray-500">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}


                </div>
                <div className="w-3/4 px-6 h-[calc(100vh-80px)] overflow-auto">
                    {React.cloneElement(steps[currentStep].component, {
                        onComplete: () => {
                            handleComplete(currentStep);
                            handleNext(); // Ensure handleNext is correctly referenced
                        },
                    })}
                    {/* <div className="flex justify-end mt-4">
                        <button
                            onClick={handleNext}
                            className={`bg-red-500 text-white px-4 py-2 rounded-md`}
                        >
                            {currentStep === steps.length - 1
                                ? "Finish"
                                : "Next"}
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Onboarding;
